import {
  IUser,
  SettingTypeOf,
  SettingValue,
  useConfigCatClient,
} from 'configcat-react';
import { useEffect, useState } from 'react';

import { useFeatureFlagOverrideContext } from '@providers/FeatureFlagOverrideProvider/FeatureFlagOverrideContext';

const useFeatureFlag = <T extends SettingValue>(
  key: string,
  defaultValue: T,
  user?: IUser,
  providerId?: string
) => {
  const client = useConfigCatClient(providerId);
  const { version } = useFeatureFlagOverrideContext();
  const [value, setValue] = useState<SettingTypeOf<T>>(
    defaultValue as SettingTypeOf<T>
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    client.getValueAsync(key, defaultValue, user).then((v) => {
      setValue(v);
      setLoading(false);
    });
    // See https://github.com/configcat/react-sdk/blob/main/src/ConfigCatHooks.tsx#L24
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client, key, defaultValue, version, JSON.stringify(user)]);

  return { value, loading };
};

export { useFeatureFlag };
